import { Cell } from "./Cell";
import { ReportStatusBadge } from "./ReportStatusBadge";
import { EvictionReportContent } from "./EvictionReportContent";
import { FullApplicant, Verification } from "../types";
import { useAuthContext } from "providers/Auth";

interface EvictionReportCellProps {
  verification: Verification;
  applicant: FullApplicant;
  hasAuditFlagEnabled: boolean;
}

export const EvictionReportCell = ({
  verification,
  applicant,
  hasAuditFlagEnabled
}: EvictionReportCellProps) => {
  const { permissions } = useAuthContext();
  return (
    <Cell
      isDataCell
      className="relative"
      isPermitted={permissions.canAccessReports.housingCourtReport}
      showRestrictedFlag={!permissions.canAccessReports.housingCourtReport}
    >
      <EvictionReportContent
        verification={verification}
        applicant={applicant}
        hasAuditFlagEnabled={hasAuditFlagEnabled}
      />
      <ReportStatusBadge
        applicantStatus={applicant.application_status}
        verificationStatus={verification.status}
        executionMode={verification.settings?.execution_mode}
      />
    </Cell>
  );
};
